import React, { useEffect } from "react";
import BackgroundImage from '../../assets/backgroundLogin.jpg';
import { useState } from "react";
import { Icon } from 'react-icons-kit';
import { eyeOff } from 'react-icons-kit/feather/eyeOff';
import { eye } from 'react-icons-kit/feather/eye';
import { useNavigate } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import Swal from 'sweetalert2';

function Login() {
  const [type, setType] = useState('password');
  const [icon, setIcon] = useState(eyeOff);
  const [email, setEmail] = useState('');
  const [password, setPasword] = useState('');
  const navigate = useNavigate();
  let headers = new Headers();
  let url = "https://trototbe.azurewebsites.net/api/Users/login";
  headers.append('Content-Type', 'application/json');

  useEffect(() => {
    if (localStorage) {
      localStorage.removeItem("Token");
      localStorage.removeItem("Role");
      localStorage.removeItem("Id");
    }
  }, [])

  const togglePassword = async () => {
    if (type === 'password') {
      setIcon(eye);
      setType('text');
    } else {
      setIcon(eyeOff);
      setType('password');
    }
  };

  const handleEmailChange = event => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = event => {
    setPasword(event.target.value);
  };

  const fetchUserData = async (e) => {
    e.preventDefault();
    const res = await fetch(url, { mode: 'cors', method: 'POST', headers: headers, body: JSON.stringify({ "email": email, "password": password })});
    if (res.status === 200) {
      const data = await res.text();
      localStorage.setItem("Token", data);
      localStorage.setItem("Role", jwtDecode(data).Role);
      localStorage.setItem("Id", jwtDecode(data).UserId);
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Đăng nhập thành công!',
        showConfirmButton: false,
        timer: 1500
      })
      if (jwtDecode(data).Role === 'User' || jwtDecode(data).Role === 'Vip') {
        navigate('/home');
      }
      if (jwtDecode(data).Role === 'Admin') {
        navigate('/users');
      }
    }else{
      const data = await res.text();
      Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: data
        })
    }
  };

  return (
    <div className="w-full h-screen relative flex justify-center items-center">
      <img className="w-full h-full" src={BackgroundImage} alt="/" />
      <div className="absolute w-full h-full top-0 left-0 bg-gray-900/30"></div>
      <div className="absolute h-3/5 w-1/3 flex flex-col justify-center text-center text-white px-5 bg-white m-auto rounded-md shadow-2xl">
        <h1 className="text-black font-sans text-4xl font-semibold">Trọ Tốt</h1>
        <form className="m-10" onSubmit={fetchUserData}>
          <div>
            <input className="bg-[#F1F1F1] p-3 w-full rounded-md font-sans text-base text-black focus:outline-0" type="email" placeholder="Email" required onChange={handleEmailChange} value={email} />
            <div className="relative">
              <input className="bg-[#F1F1F1] mt-3 p-3 w-full rounded-md font-sans text-base text-black focus:outline-0" type={type} placeholder="Mật khẩu" required onChange={handlePasswordChange} value={password} />
              <div className="absolute right-5 top-6 text-black">
                <span onClick={togglePassword}><Icon icon={icon} size={25} /></span>
              </div>
            </div>
            <div>
              <button className="bg-[#6F977F] mt-5 p-2 w-full rounded-md text-black font-sans font-bold" type="submit" >Đăng nhập</button>
            </div>
            <div className="text-black font-sans mt-5 italic">
              <p>Bạn chưa có tài khoản? <a className="underline text-[#8B8B8B]" href="/register">Đăng ký</a></p>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;